module.exports = __webpack_public_path__ + "img/tiling.c26b9fb8.jpg";